import { arts } from "./arts";
import { cr } from "fire-wind-water";
import {
  RENDER_CAROUSEL,
  RENDER_CAROUSEL_UPDATE,
  RENDER_CUSTOMCONTENT,
  RENDER_CUSTOMCONTENT_UPDATE,
  RENDER_FOOTER,
  RENDER_FOOTER_UPDATE,
  RENDER_MIMAGE,
  RENDER_MIMAGE_UPDATE,
  RENDER_MIMAGETEXT,
  RENDER_MIMAGETEXT_UPDATE,
  RENDER_NAV,
  RENDER_NAV_UPDATE,
  RENDER_SIMAGE,
  RENDER_SIMAGE_UPDATE,
  RENDER_SIMAGETEXT,
  RENDER_SIMAGETEXT_UPDATE,
  RENDER_CUSTOMFORM,
  RENDER_CUSTOMFORM_UPDATE,
  RENDER_MEETING,
  RENDER_MEETING_UPDATE,
  RENDER_ARTICLEDETAIL,
  RENDER_ARTICLEDETAIL_UPDATE,
  RENDER_ARTICLEDETAILBANNER,
  RENDER_ARTICLEDETAILBANNER_UPDATE,
  RENDER_VIDEO,
  RENDER_VIDEO_UPDATE,
  RENDER_FILE,
  RENDER_FILE_UPDATE,
  RENDER_REGISTRATION,
  RENDER_REGISTRATION_UPDATE,
  RENDER_SIDEBAR,
  RENDER_SIDEBAR_UPDATE,
  RENDER_NULL,
  RENDER_NULL_UPDATE,
  RENDER_FILEDETAIL,
  RENDER_FILEDETAIL_UPDATE,
  RENDER_SEARCH,
  RENDER_SEARCH_UPDATE,
  RENDER_SEARCHDETAIL,
  RENDER_SEARCHDETAIL_UPDATE,
  renderAdd,
  renderUpdate,
  RENDER_TAB,
} from "./type";

export const $renderComponent: any = {};
export const $renderComponentFn: any = {};

export function $skCmsAddRender(str, type, fn) {
  if (!$renderComponentFn[type]) {
    $renderComponentFn[type] = {
      pc: arts[type].pc,
      wap: arts[type].wap,
    };
  }
  $renderComponentFn[type][str] = fn;
  if (cr.isString(type)) {
    $renderComponent[`RENDER_${type}`] = (d, t) => {
      return renderAdd(
        d,
        t,
        $renderComponentFn[type].pc,
        $renderComponentFn[type].wap
      );
    };
    $renderComponent[`RENDER_${type}_UPDATE`] = (d, t) => {
      return renderUpdate(
        d,
        t,
        $renderComponentFn[type].pc,
        $renderComponentFn[type].wap
      );
    };
  }
}

const render = {
  RENDER_SIMAGE,
  RENDER_SIMAGE_UPDATE,
  RENDER_SIMAGETEXT,
  RENDER_SIMAGETEXT_UPDATE,
  RENDER_MIMAGE,
  RENDER_MIMAGE_UPDATE,
  RENDER_MIMAGETEXT,
  RENDER_MIMAGETEXT_UPDATE,
  RENDER_CAROUSEL,
  RENDER_CAROUSEL_UPDATE,
  RENDER_NAV,
  RENDER_NAV_UPDATE,
  RENDER_FOOTER,
  RENDER_FOOTER_UPDATE,
  RENDER_CUSTOMCONTENT,
  RENDER_CUSTOMCONTENT_UPDATE,
  RENDER_CUSTOMFORM,
  RENDER_CUSTOMFORM_UPDATE,
  RENDER_MEETING,
  RENDER_MEETING_UPDATE,
  RENDER_ARTICLEDETAIL,
  RENDER_ARTICLEDETAIL_UPDATE,
  RENDER_ARTICLEDETAILBANNER,
  RENDER_ARTICLEDETAILBANNER_UPDATE,
  RENDER_VIDEO,
  RENDER_VIDEO_UPDATE,
  RENDER_FILE,
  RENDER_FILE_UPDATE,
  RENDER_REGISTRATION,
  RENDER_REGISTRATION_UPDATE,
  RENDER_SIDEBAR,
  RENDER_SIDEBAR_UPDATE,
  RENDER_NULL,
  RENDER_NULL_UPDATE,
  RENDER_FILEDETAIL,
  RENDER_FILEDETAIL_UPDATE,
  RENDER_SEARCH,
  RENDER_SEARCH_UPDATE,
  RENDER_SEARCHDETAIL,
  RENDER_SEARCHDETAIL_UPDATE,
  RENDER_TAB,
};

export function $renderAdd(type, category, data): string {
  const s1 = `RENDER_${type}`;
  const $render = $renderComponent[s1] || render[s1];
  return $render(data, category);
}

export function $renderUpdate(category, data): any {
  const s1 = `RENDER_${data.type}_UPDATE`;
  const $render = $renderComponent[s1] || render[s1];
  return $render(data, category);
}
